import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Layout from '../Layout/Layout'
import { routes } from './Route'
import { authRoutes } from './AuthPaths'
import PermissionRoute from './PermissionRoute'

export default function LayoutRoutes() {
    return (
        <>
            <Routes>
                {routes.map(({ path, element, permission }: any, i) => (
                    <Route element={<Layout />} key={i}>
                        <Route 
                            path={path} 
                            element={permission ? <PermissionRoute permission={permission}>{element}</PermissionRoute> : element} 
                        />
                    </Route>
                ))}
                {authRoutes.map(({ path, element }, i) => (
                    <Route key={i} path={path} element={element} />
                ))}
            </Routes>
        </>
    )
}